import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddAndEdit from './component/ModalAddAndEdit';
import { services_create, services_delete, services_list, services_update } from '../../services/apis';
import { HeaderTableCus, LIST_UNITS, TYPE_MODAL } from '../../constants/constants';
import { useSelector } from 'react-redux';
import { formatNumber } from '../../utils/funcHelper';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

const ListServicesPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const userReducer = useSelector((state) => state.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => <a onClick={() => handleEditService(record)} style={{paddingLeft: 12}}>{text}</a>,
        },
        // {
        //     title: 'Đơn vị',
        //     dataIndex: 'unit',
        //     key: 'unit',
        //     align: 'center',
        //     render: (text, record, index) => <div>{text ? LIST_UNITS.find(item => item.value === text)?.label : ''}</div>,
        // },
        {
            title: 'Giá dịch vụ (VNĐ)',
            dataIndex: 'price',
            key: 'price',
            align: 'right',
            render: (text, record, index) => <div style={{paddingRight: 12}}><strong>{formatNumber(parseInt(text), 0)}</strong></div>,
        },
        {
            title: 'Mô tả',
            dataIndex: 'description',
            key: 'description',
            render: (text, record, index) => <div style={{paddingLeft: 12}}>{text}</div>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleEditService(record)} >Sửa</a>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteService(record)}
                        okText="Xóa"
                        cancelText="Hủy"
                        placement="topRight"
                    >
                        <a style={{ color: 'red' }}>Xóa</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };
    
    const handleDeleteService = async (record) => {
        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await services_delete(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Xoá thành công');
                getDataServices(true);
            }
            else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const handleEditService = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa dịch vụ');
    }
    const handleAddService = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm dịch vụ');
    }
   
    const getDataServices = async (showLoading) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
            }
            if (showLoading) setLoading(true);
            const res = await services_list(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
        

    }

    const onFinish = async (dataForm) => {
        getDataServices(true);
    };
    const callApiAddService = async (data) => {
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id
            }
            const res = await services_create(params);  
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới thành công');
                getDataServices(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }          
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const callApiUpdateService = async (data) => {
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await services_update(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataServices(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiAddService(data);
        } else {
            callApiUpdateService(data);
        }

    }

    useEffect(() => {
        getDataServices(true)
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button 
                                type="primary" 
                                htmlType="submit"
                                icon={<SearchOutlined />}
                            >
                                Tìm kiếm
                            </Button>
                            <Button danger 
                                onClick={handleAddService}
                                icon={<PlusOutlined />}
                            >
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
                scroll={{ y: 600, x: 'max-content' }}
            />
            <ModalAddAndEdit
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListServicesPage);